<template>
  <el-container style="height: 100%">
    <el-aside :style="{width: getLanguage === 'en' ? '64px' : '60px',height: '100%'}" class="aside-view">
      <sidebar />
      <div v-if="$store.state.user.sidType === 1" class="enjoy-page-tag-container">
        <EnjoyPageTag></EnjoyPageTag>
      </div>
      <navbar />
    </el-aside>
    <el-container>
      <el-header style="height: auto;">
        <PageTagList></PageTagList>
        <div class="top-tip__box">
          <TopTip></TopTip>
        </div>
      </el-header>
      <el-main style="padding: 0; position: relative; overflow:hidden;border-bottom: 0;" class="main-box">
        <keep-alive>
          <router-view v-if="$route.meta.keep" />
        </keep-alive>
        <router-view v-if="!$route.meta.keep" :key="$route.fullPath" />
      </el-main>
    </el-container>
    <vue-draggable-resizable v-show="initBtnShow"  :w="80" :h="40" class-name="init-show-btn" :on-drag-start="dragStart" @dragstop="initClick=false" @click.native="initShow">
      <!-- <i class="iconhuice icon-chushihua"></i> -->
      <i class="el-icon-loading"></i>&nbsp;
      初始化
    </vue-draggable-resizable>
    <UpdateNotice />
  </el-container>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import Sidebar from './components/side-bar'
import Navbar from './components/nav-bar'
import EnjoyPageTag from './components/EnjoyPageTag.vue'
import InitProcess from './components/init-process'
import TopTip from './components/TopTip.vue'
import UpdateNotice from '@/components/UpdateNotice'
import { mapGetters } from 'vuex'
import { downloadFileFromOss } from '@/services/utils/modules/oss'
// eslint-disable-next-line no-unused-vars
import WS from '@/services/request/socketClass'
import PageTagList from './components/PageTagList.vue'

export default {
  name: 'Layout',
  components: {
    VueDraggableResizable,
    Sidebar,
    Navbar,
    UpdateNotice,
    TopTip,
    PageTagList,
    EnjoyPageTag,
  },
  data() {
    return {
      initClick: false,
      ws: null,
    }
  },
  computed: {
    ...mapGetters([
      'initBtnShow'
    ]),
    getLanguage() {
      return this.$i18n.locale
    }
  },
  created() {
    this.initWs()
  },
  methods: {
    initWs() {
      this.ws = new WS()
      this.ws.connect({
        successCb: () => {
          this.ws.sub('/user/queue/download', (data, headers) => {
            // 累加 更新列表计数器, 通知列表页主动更新
            this.$store.commit('downloadCenter/INC_MSG_COUNTER')
            // 全局提示
            console.log(data.content)
            const content = JSON.parse(data.content)
            this.$notify({
              title: '提示',
              dangerouslyUseHTMLString: true,
              message:
                content.path
                  ? <div class="mt10 hc-color-main pointer" onClick={() => downloadFileFromOss(content.path)}>{content.msg}</div>
                  : content.msg,
              position: 'bottom-right',
              type: content.path ? 'success' : 'error',
              duration: 10000,
              offset: 40,
            })
          })
          this.ws.sub('/user/queue/sales', (data, headers) => {
            this.$store.commit('immediateSales/SET_LAST_TASK_STATUS', data.content?.status)
            if (data.content?.status === 300) {
              this.$notify({
                title: '提示',
                message: data.content?.msg,
                position: 'bottom-right',
                type: 'success',
                duration: 10000,
                offset: 40,
              })
            }
          })
        }
      })
    },
    dragStart() {
      this.initClick = true
    },
    initShow() {
      if (this.initClick) {
        this.$dialog({
          title: '数据同步进程',
          width: 'middle',
          component: () => <InitProcess />
        })
      }
    }
  },
  destroyed() {
    this.ws && this.ws.disconnect()
  },
}
</script>

<style lang="scss" scoped>
.aside-view {
  position: relative;
  width: 60px;
  background: #151C2F;
  // background: #ffffff;
  padding: 0;
  // border-right: 1px solid $G3;
  // 覆盖 <aside > style
  border-radius: 0;
  margin-bottom: 0px;
  overflow: hidden;
}
.tags-wrapper {
  display: inline-block;
  width: calc(100% - 236px);
}
.scroll-pan {
  height: 100%;
}
.init-show-btn{
  border-radius: 5px;
  background-color: $main-color;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 50px;
  right: 20px;
  cursor: pointer;
  z-index: 10 !important;
  .iconhuice{
    font-size: 22px;
  }
}

.main-box {
  background-color: $--brand-background-color;
}

.enjoy-page-tag-container {
  position: absolute;
  bottom: 86px;
  left: 0;
  width: 100%;

  display: flex;
  justify-content: center;
}

.top-tip__box {
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 16px;
  padding-right: 16px;
}
</style>
